import React, { useState } from "react";
import "./Use.css"; 

function Use() {
  const [selectedCollege, setSelectedCollege] = useState("");
  const [selectedSemester, setSelectedSemester] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [selectedOption, setSelectedOption] = useState("");

  // Sample data for the divs
  const data = [
    { id: 1, title: "Maths Paper", uplby: "Title", college: "SSTC Bhilai", semester: "semester1", subject: "Math", option: "PYQ",link:"https://drive.google.com/file/d/1yNzbqIsKbFA_3albNCbQDKh7_Hnl-e1r/view?usp=sharing"},
    { id: 2, title: "Science Notes", uplby: "Title", college: "BIT Raipur", semester: "semester2", subject: "Science", option: "Notes",link: "https://drive.google.com/file/d/1yNzbqIsKbFA_3albNCbQDKh7_Hnl-e1r/view?usp=sharing "},
    { id: 3, title: "DBMS Notes", uplby: "Title", college: "NIT Raipur", semester: "semester4", subject: "DBMS", option: "Notes",link: "https://drive.google.com/file/d/1yNzbqIsKbFA_3albNCbQDKh7_Hnl-e1r/view?usp=sharing "},
    { id: 4, title: "Java PYQ", uplby: "Title", college: "SSTC Bhilai", semester: "semester3", subject: "Java", option: "PYQ",link:"https://drive.google.com/file/d/1yNzbqIsKbFA_3albNCbQDKh7_Hnl-e1r/view?usp=sharing "},
    { id: 5, title: "Python Notes", uplby: "Title", college: "BITRAIPUR", semester: "semester2", subject: "Python", option: "Notes",link: " https://drive.google.com/file/d/1yNzbqIsKbFA_3albNCbQDKh7_Hnl-e1r/view?usp=sharing" },
    { id: 6, title: "C/C++ Notes", uplby: "Title", college: "NIT Raipur", semester: "semester6" , subject: "C/C++", option: "Notes",link: " https://drive.google.com/file/d/1yNzbqIsKbFA_3albNCbQDKh7_Hnl-e1r/view?usp=sharing"},
    { id: 7, title: "Science PYQ", uplby: "Title", college: "SSTC Raipur", semester: "semester7", subject: "DSA", option: "PYQ",link:" https://drive.google.com/file/d/1yNzbqIsKbFA_3albNCbQDKh7_Hnl-e1r/view?usp=sharing"},
    { id: 8, title: "DBMS Notes", uplby: "Title", college: "BIT Durg", semester: "semester3", subject: "Science", option: "Notes",link: "https://drive.google.com/file/d/1yNzbqIsKbFA_3albNCbQDKh7_Hnl-e1r/view?usp=sharing "},
    { id: 9, title: "DBMS Notes", uplby: "Title", college: "NIT Raipur", semester: "semester5", subject: "DBMS", option: "Notes",link:"https://drive.google.com/file/d/1yNzbqIsKbFA_3albNCbQDKh7_Hnl-e1r/view?usp=sharing " },
    { id: 10, title: "Science Notes", uplby: "Title", college: "BIT Raipur", semester: "semester2", subject: "Science", option: "Notes",link: "https://drive.google.com/file/d/1yNzbqIsKbFA_3albNCbQDKh7_Hnl-e1r/view?usp=sharing " },
    { id: 11, title: "DBMS Notes", uplby: "Title", college: "NIT Raipur", semester: "semester6" , subject: "DBMS", option: "Notes",link: " https://drive.google.com/file/d/1yNzbqIsKbFA_3albNCbQDKh7_Hnl-e1r/view?usp=sharing"},
    { id: 12, title: "Maths PYQ", uplby: "Title", college: "SSTC Bhilai ", semester: "semester7", subject: "Math", option: "PYQ",link:"https://drive.google.com/file/d/1yNzbqIsKbFA_3albNCbQDKh7_Hnl-e1r/view?usp=sharing "},
    { id: 13, title: "Science PYQ", uplby: "Title", college: "BIT Durg", semester: "semester3", subject: "Science", option: "Notes",link: " https://drive.google.com/file/d/1yNzbqIsKbFA_3albNCbQDKh7_Hnl-e1r/view?usp=sharing"},
    { id: 14, title: "DSA Notes", uplby: "Title", college: "NIT Raipur", semester: "semester5", subject: "DSA", option: "Notes",link:"https://drive.google.com/file/d/1yNzbqIsKbFA_3albNCbQDKh7_Hnl-e1r/view?usp=sharing " },
  { id: 15, title: "DBMS Notes", uplby: "Title", college: "NIT Raipur", semester: "semester6" , subject: "DBMS", option: "Notes",link: "https://drive.google.com/file/d/1yNzbqIsKbFA_3albNCbQDKh7_Hnl-e1r/view?usp=sharing "},

  ];

  // Filter the data based on selected filter options
  const filteredData = data
    .filter(item => !selectedCollege || item.college === selectedCollege)
    .filter(item => !selectedSemester || item.semester === selectedSemester)
    .filter(item => !selectedSubject || item.subject === selectedSubject)
    .filter(item => !selectedOption || item.option === selectedOption);

  return (
    <div className="use">
      <div className="filters">
        <h2 className="fil">Filter Out</h2>
        <label>
          College
          <select value={selectedCollege} onChange={e => setSelectedCollege(e.target.value)}>
            <option value="">All</option>
            <option value="">Select College</option>
            <option value="BIT Raipur">BIT Raipur</option>
            <option value="NIT Raipur">NIT Raipur</option>
            <option value="SSTC Raipur">SSTC Raipur</option>
            <option value="SSTC Bhilai">SSTC Bhilai</option>
            <option value="GEC Raipur">GEC Raipur</option>
            <option value="AMITY Raipur">AMITY Raipur</option>
            <option value="BIT Durg">BIT DURG</option>
            {/* Add more options */}
          </select>
        </label>
        <label>
          Semester
          <select value={selectedSemester} onChange={e => setSelectedSemester(e.target.value)}>
            <option value="">All</option>
            <option value="">Select Semester</option>
            <option value="semester1">Semester 1</option>
            <option value="semester2">Semester 2</option>
            <option value="semester3">Semester 3</option>
            <option value="semester4">Semester 4</option>
            <option value="semester5">Semester 5</option>
            <option value="semester6">Semester 6</option>
            <option value="semester7">Semester 7</option>
            <option value="semester8">Semester 8</option>
            {/* Add more options */}
          </select>
        </label>
        <label>
          Subject
          <select value={selectedSubject} onChange={e => setSelectedSubject(e.target.value)}>
            <option value="">All</option>
            <option value="Math">Maths</option>
            <option value="Science">Science</option>
            <option value="DBMS">DBMS</option>
            <option value="Operating System">Operating System</option>
            <option value="Java">Java</option>
            <option value="Python">Python</option>
            <option value="C/C++">C/C++</option>
            <option value="DSA">DSA</option>
            {/* Add more options */}
          </select>
        </label>
        <label>
          Option
          <select value={selectedOption} onChange={e => setSelectedOption(e.target.value)}>
            <option value="">All</option>
            <option value="PYQ">PYQ</option>
            <option value="Notes">Notes</option>
            {/* Add more options */}
          </select>
        </label>
      </div>
      <div className="data">
        {/* <h2 className="dat">Data</h2> */}
        {filteredData.length === 0 ? (
          <p>No matching data found.</p>
        ) : (
          <div className="data-list">
            {filteredData.map(item => (
              <div key={item.id} className="data-item">
                <h3>{item.title}</h3>
                <p>{item.college}</p>
                <p>{item.semester}</p>
                <p> {item.subject}</p>
                <p> {item.option}</p>
                <a className="" href=" "><button>Download</button></a>
              </div>
            ))}
            
          </div>
        )}
        
      </div>
    </div>
  );
}

export default Use;
